export default "__VITE_ASSET__BIS6pmoK__"